module.exports = __webpack_public_path__ + "static/media/030-spaceship.633c84ca.svg";